require('./bulkTransferShowContainer.scss')

module.exports = {
  template: require('./bulkTransferShowContainer.pug')()
  controller: require('./bulkTransferShowContainer.ctrl')
}
